/*
 * AdvaHealth Solutions Pty. Ltd. ("AHS") CONFIDENTIAL
 * Copyright (c) 2022 AdvaHealth Solutions Pty. Ltd. All Rights Reserved.
 *
 * NOTICE:  All information contained herein is, and remains the property of AHS. The intellectual and technical concepts contained
 * herein are proprietary to AHS and are protected by trade secret or copyright law.
 * Dissemination of this information or reproduction of this material is strictly forbidden unless prior written permission is obtained
 * from AHS.  Access to the source code contained herein is hereby forbidden to anyone except current AHS employees, managers or contractors who have executed
 * Confidentiality and Non-disclosure agreements explicitly covering such access.
 *
 * The copyright notice above does not evidence any actual or intended publication or disclosure  of  this source code, which includes
 * information that is confidential and/or proprietary, and is a trade secret, of AHS. ANY REPRODUCTION, MODIFICATION, DISTRIBUTION, PUBLIC  PERFORMANCE,
 * OR PUBLIC DISPLAY OF OR THROUGH USE  OF THIS  SOURCE CODE  WITHOUT  THE EXPRESS WRITTEN CONSENT OF COMPANY IS STRICTLY PROHIBITED, AND IN VIOLATION OF APPLICABLE
 * LAWS AND INTERNATIONAL TREATIES.  THE RECEIPT OR POSSESSION OF  THIS SOURCE CODE AND/OR RELATED INFORMATION DOES NOT CONVEY OR IMPLY ANY RIGHTS
 * TO REPRODUCE, DISCLOSE OR DISTRIBUTE ITS CONTENTS, OR TO MANUFACTURE, USE, OR SELL ANYTHING THAT IT  MAY DESCRIBE, IN WHOLE OR IN PART.
 */

/* eslint-disable @typescript-eslint/no-explicit-any */
import React, { FunctionComponent, useEffect, useState } from "react";

import { useTranslation } from "react-i18next";
import Select from "react-select";

import { OrganisationFieldProps } from "../../../types/rule";
import { getSelectStyles, ORGANISATION } from "../../../constant";

const Organisation: FunctionComponent<OrganisationFieldProps> = ({
  disabled,
  id,
  parent,
  errors,
  organisationIds,
  onValueChangeHandler,
  isDark,
  options,
}: OrganisationFieldProps) => {
  const { t } = useTranslation();
  const [selectedOptions, setSelectedOptions] = useState(null);

  useEffect(() => {
    if (options?.length > 0) {
      setSelectedOptions(
        options.filter((item) => organisationIds?.includes(item.value))
      );
    }
  }, [options, organisationIds]);

  const dispatchNewValue = (data: string[]) => {
    onValueChangeHandler(
      {
        scope: "conditions",
        id,
        type: ORGANISATION,
        stringCollectionProperty: {
          property: "organisationId",
          operator: "IN",
          values: data,
        },
      },
      parent
    );
  };

  const hasError = () => {
    return (
      errors?.find((item) => item.id === id && item.type === ORGANISATION) !==
      undefined
    );
  };

  return (
    <div className="row">
      <div className="col-md-4 col-xs-12 mb-1">
        <Select
          styles={getSelectStyles(isDark)}
          menuPlacement="auto"
          menuPosition="fixed"
          isDisabled={disabled}
          id={`${id}_operator`}
          name="operator"
          classNamePrefix="form-control-select"
          options={options}
          placeholder={t("select")}
          isMulti
          onChange={(selectedItems) => {
            dispatchNewValue(selectedItems.map((item) => item.value));
          }}
          value={selectedOptions}
        />
        {hasError() && (!organisationIds || organisationIds?.length == 0) && (
          <label
            className="validation-invalid-label"
            htmlFor={`${id}_hl7_field`}
          >
            {t("form:hl7.field_required")}
          </label>
        )}
      </div>
    </div>
  );
};

export default Organisation;
